module.exports = __webpack_public_path__ + "img/activity-setting.ffe2786c.png";